import {
  FETCH_MESSAGE_CATALOG,
  FETCH_MESSAGE_CATALOG_SUCCESS,
  FETCH_MESSAGE_CATALOG_ERROR,
  SYNC_MESSAGE_CATALOG_SUCCESS,
} from '../constant';

import { getDataFromService } from '../../service';
import { MESSAGE_CATALOG_URL } from '../constant/app.properties';

const { REACT_APP_SERVICE_URL } = window.weeksWebCloudConfig;

/** Returns Message Catalog Action Type */
const fetchMessageCatalog = () => ({
  type: FETCH_MESSAGE_CATALOG,
});

/** Returns Message Catalog Response Obejct */
const fetchMessageCatalogSuccess = (messageGroupId, messageGroupMap) => ({
  type: FETCH_MESSAGE_CATALOG_SUCCESS,
  payload: {
    id: messageGroupId,
    messageGroupMap,
  },
});
const fetchMessageCatalogError = messageGroupId => ({
  type: FETCH_MESSAGE_CATALOG_ERROR,
  payload: {
    id: messageGroupId,
  },
});

/** Returns Local Store Message Object  */
const syncStoreWithMsgFromStorageSuccess = messages => ({
  type: SYNC_MESSAGE_CATALOG_SUCCESS,
  payload: {
    ...messages,
  },
});

/** Returns Message Catalog Error Obejct */
// const fetchMessageCatalogError = response => ({
//   type: FETCH_MESSAGE_CATALOG_ERROR,
//   payload: {
//     ...response,
//   },
// });

const fetchMessageCatalogInfo = async (messageGroupId, msgLocale, msgBrandCode, customerId) => {
  const mesgUrl = `${REACT_APP_SERVICE_URL}${MESSAGE_CATALOG_URL}?messageGroup=${messageGroupId}&brand=${msgBrandCode}&brandId=1&appType=rcio`;
  const serviceResponse = await getDataFromService({
    url: mesgUrl,
    method: 'GET',
    customerID: customerId,
    userLocale: msgLocale,
    // userLocale:'ja_JP',
  });
  return serviceResponse;
};

/* Checks if messages for the routed module is present in redux store. */
export const getMessageCatalog = route => async (dispatch, getState) => {
  const { messageGroupId: messageGroupIdList } = route;
  Array.isArray(messageGroupIdList) && messageGroupIdList.forEach(async (messageGroupId) => {
    dispatch(fetchMessageCatalog());
    const messagesInStore = getState().CommonReducer.messageCatalog;
    const messageGroupMap = messagesInStore ? messagesInStore[messageGroupId] : null;
    if (!messageGroupMap) {
      const { customerId } = getState().CommonReducer;
      const msgLocale = getState().CommonReducer.locale;
      const msgBrandCode = getState().CommonReducer.customerProfile.brandCode;
      const serviceResponse = await fetchMessageCatalogInfo(messageGroupId, msgLocale, msgBrandCode, customerId);

      if (serviceResponse.status === 200) {
        if (localStorage) {
          // if Localstorage is not avialable. Chaching will be deisabled.
          const messageVal = JSON.parse(localStorage.getItem('message')) || {};
          messageVal[messageGroupId] = serviceResponse.data.data[msgBrandCode][msgLocale][messageGroupId];
          if (messageVal[messageGroupId]) {
            messageVal[messageGroupId].isMcServiceCallCompleted = true;
            localStorage.setItem('message', JSON.stringify(messageVal));
          }

          // localStorage.setItem('message', JSON.stringify(messageVal));
        }
        dispatch(fetchMessageCatalogSuccess(messageGroupId, serviceResponse.data));
      } else {
        dispatch(fetchMessageCatalogError(messageGroupId));
        /* dispatch(commonAction.logErrorMessage(serviceResponse, 'Message catalog')); */
      }
    }
  });
};

/** Dispatches Local Store Object to Redux Store */
export const syncStoreWithMsgFromStorage = () => async (dispatch) => {
  // Need to discuss how to refresh Local Storage. And can be done here.
  dispatch(fetchMessageCatalog());
  const messageMapInStorage = localStorage.getItem('message');
  if (messageMapInStorage) {
    dispatch(syncStoreWithMsgFromStorageSuccess(JSON.parse(messageMapInStorage)));
  } else {
    // console.log('No message stored in localstorage yet. Module will fetch it when loaded.');
  }
};
